export enum Mandatory {
    REQUIRED = 'required',
    OPTIONAL = 'optional',
    HIDDEN = 'hidden',
}
